import { httpClient } from '@/services/http/httpClient'

export async function deleteUserMemberPortfolio({
  portfolioId,
  userId,
}: {
  portfolioId: string
  userId: string
}) {
  return await httpClient.delete(
    `/projects/portfolios/${portfolioId}/member/${userId}`,
  )
}
